import { windowCeiling } from "@colossus/contracts";
import { m } from "./paraglide/messages.js";
import { count, plural } from "./format.ts";
import type { Locale } from "./locale.ts";

export const ALL_TIME = "all";

export const windowMax = (tenant: { readonly retentionDays: number | null }): number =>
  windowCeiling(tenant.retentionDays);

export const windowFits = (days: number | null, max: number, allowAll = true): boolean =>
  days === null ? allowAll : Number.isInteger(days) && days >= 1 && days <= max;

export const spanWords = (span: string, locale: Locale): string => {
  if (span === ALL_TIME) return m.perks_span_all();
  const days = Number(span);
  return plural(locale, days, { one: m.perks_span_one, other: m.perks_span })({
    days: count(locale, days),
    n: days,
  });
};

export const windowWords = (days: number | null, locale: Locale): string => {
  if (days === null) return m.window_all();
  return plural(locale, days, { one: m.window_last_one, other: m.window_last })({
    days: count(locale, days),
    n: days,
  });
};

export const windowDaysOf = (text: string): number | null => {
  const trimmed = text.trim();
  const days = Number(trimmed);
  return trimmed !== "" && Number.isInteger(days) && days >= 1 ? days : null;
};
